export type BlogPostMetadata = {
  slug: string
  title: string
  description: string
  category: string
  publishedDate: string
  updatedDate?: string
  readingTime: string
  author: string
  featured?: boolean
  seoTitle: string
  seoDescription: string
  heroImage?: string
  imageAlt?: string
}

export const BLOG_POSTS: BlogPostMetadata[] = [
  {
    slug: 'shadow-it-pdf-tools-confidential-data',
    title: 'Shadow IT and PDF Tools: How Unapproved Uploads Can Expose Confidential Data',
    description: 'Learn why employees use unapproved online PDF tools, the compliance risks of uploading sensitive documents, and how local processing reduces unnecessary third-party document transfers.',
    category: 'Security & Privacy',
    publishedDate: '2026-08-16',
    readingTime: '12 min read',
    author: 'StayInBrowser',
    featured: true,
    seoTitle: 'Shadow IT & PDF Tools: The Risk of Uploading Confidential Files | StayInBrowser',
    seoDescription: 'Why employees upload confidential NDAs and contracts to free PDF tools, the security risks of Shadow IT, and how local-first document processing helps.',
    heroImage: '/assets/blog/shadow-it-pdf.svg',
    imageAlt: 'Illustration comparing local browser document processing with traditional server uploads across a trust boundary.'
  },
]

export function getBlogPost(slug: string): BlogPostMetadata | undefined {
  return BLOG_POSTS.find((post) => post.slug === slug)
}
